/**
 * CommonCodeItemCard Component
 * 개별 공통코드 입력 카드
 */
import React from 'react';
import FormInput from '@/shared/components/forms/FormInput';
import { CommonCodeFormItem } from '../utils/commonCodeCreateUtils';

interface CommonCodeItemCardProps {
    code: CommonCodeFormItem;
    index: number;
    canDelete: boolean;
    onChange: (id: string, e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
    onRemove: (id: string) => void;
    onRemoveValueField: (id: string, fieldIndex: number) => void;
}

const ValueField: React.FC<{
    code: CommonCodeFormItem;
    fieldNum: number;
    onChange: (id: string, e: React.ChangeEvent<HTMLInputElement>) => void;
    onRemove: (id: string, fieldIndex: number) => void;
}> = ({ code, fieldNum, onChange, onRemove }) => {
    const fieldName = `val${fieldNum}` as keyof CommonCodeFormItem;
    const value = code[fieldName] as string;

    return (
        <div className="form-group form-group-with-delete">
            <FormInput
                id={`${code.id}-val${fieldNum}`}
                name={`val${fieldNum}`}
                type="text"
                label={`코드값${fieldNum}`}
                value={value}
                onChange={(e) => onChange(code.id, e)}
                placeholder={`코드값${fieldNum}을 입력하세요`}
            />
            <button
                type="button"
                onClick={() => onRemove(code.id, fieldNum)}
                className="delete-field-button"
                title={`코드값${fieldNum} 삭제`}
            >
                <i className="fas fa-times"></i>
            </button>
        </div>
    );
};

const CommonCodeItemCard: React.FC<CommonCodeItemCardProps> = ({
                                                                   code,
                                                                   index,
                                                                   canDelete,
                                                                   onChange,
                                                                   onRemove,
                                                                   onRemoveValueField,
                                                               }) => {
    return (
        <div className="common-code-item">
            <div className="common-code-item-header">
                <h3 className="common-code-item-title">공통코드 {index + 1}</h3>
                {canDelete && (
                    <button
                        type="button"
                        onClick={() => onRemove(code.id)}
                        className="delete-common-code-button"
                        title="공통코드 삭제"
                    >
                        <i className="fas fa-times"></i>
                    </button>
                )}
            </div>

            <div className="form-row">
                <div className="form-group">
                    <FormInput
                        id={`${code.id}-comCode`}
                        name="comCode"
                        type="text"
                        label="공통코드"
                        value={code.comCode}
                        onChange={(e) => onChange(code.id, e)}
                        placeholder="공통코드를 입력하세요"
                        required
                    />
                </div>
                <div className="form-group">
                    <FormInput
                        id={`${code.id}-comCdName`}
                        name="comCdName"
                        type="text"
                        label="공통코드명"
                        value={code.comCdName}
                        onChange={(e) => onChange(code.id, e)}
                        placeholder="공통코드명을 입력하세요"
                        required
                    />
                </div>
            </div>

            <div className="form-row">
                <div className="form-group">
                    <label htmlFor={`${code.id}-comSeqno`} className="form-label">
                        공통코드순번
                    </label>
                    <input
                        type="number"
                        id={`${code.id}-comSeqno`}
                        name="comSeqno"
                        className="form-input"
                        value={code.comSeqno}
                        onChange={(e) => onChange(code.id, e)}
                        placeholder="공통코드순번을 입력하세요"
                        autoComplete="off"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor={`${code.id}-useYn`} className="form-label">
                        사용여부
                    </label>
                    <select
                        id={`${code.id}-useYn`}
                        name="useYn"
                        value={code.useYn}
                        onChange={(e) => onChange(code.id, e)}
                        className="form-select"
                        autoComplete="off"
                    >
                        <option value="Y">사용</option>
                        <option value="N">미사용</option>
                    </select>
                </div>
            </div>

            {code.visibleValueFields >= 1 && (
                <div className="form-row">
                    <ValueField code={code} fieldNum={1} onChange={onChange} onRemove={onRemoveValueField} />
                    {code.visibleValueFields >= 2 && (
                        <ValueField code={code} fieldNum={2} onChange={onChange} onRemove={onRemoveValueField} />
                    )}
                </div>
            )}

            {code.visibleValueFields >= 3 && (
                <div className="form-row">
                    <ValueField code={code} fieldNum={3} onChange={onChange} onRemove={onRemoveValueField} />
                    {code.visibleValueFields >= 4 && (
                        <ValueField code={code} fieldNum={4} onChange={onChange} onRemove={onRemoveValueField} />
                    )}
                </div>
            )}

            {code.visibleValueFields >= 5 && (
                <div className="form-row">
                    <ValueField code={code} fieldNum={5} onChange={onChange} onRemove={onRemoveValueField} />
                </div>
            )}
        </div>
    );
};

export default CommonCodeItemCard;
